"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderEdit = void 0;
const Base_1 = require("./Base");
exports.PostOrderEdit = {
    url: Base_1.URL_BASE + "/OrderEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostOrderEdit.js.map